import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from 'src/app/modules/shared/components/loading/loading.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
  }

  constructor(private loadingService: LoadingService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const skipLoader = request.headers.has('x-skip-loader');
    if (!skipLoader) {
      this.loadingService.showLoading();
    }

    request = request.clone({
      setHeaders: {
        platform: 'desktop',
      },
      headers: request.headers.delete('x-skip-loader'),
    });

    return next.handle(request).pipe(
      finalize(() => {
        if (!skipLoader) {
          this.loadingService.hideLoading();
        }
      }),
    );
  }
}
